export enum ColorEnum {
  ACCENT_5 = 'accent-5',
  ACCENT_25 = 'accent-25',
  ACCENT_50 = 'accent-50',
  ACCENT_75 = 'accent-75',
  ACCENT_100 = 'accent-100',
  BLACK = 'black',
  BLUE_5 = 'blue-5',
  BLUE_25 = 'blue-25',
  BLUE_50 = 'blue-50',
  BLUE_75 = 'blue-75',
  BLUE_100 = 'blue-100',
  BRAND_5 = 'brand-5',
  BRAND_25 = 'brand-25',
  BRAND_50 = 'brand-50',
  BRAND_75 = 'brand-75',
  BRAND_100 = 'brand-100',
  DEFAULT = 'default',
  ERROR = 'error',
  GREEN_5 = 'green-5',
  GREEN_25 = 'green-25',
  GREEN_50 = 'green-50',
  GREEN_75 = 'green-75',
  GREEN_100 = 'green-100',
  GREEN_LIGHT = 'green-light',
  INFO = 'info',
  NEUTRAL_0 = 'neutral-0',
  NEUTRAL_10 = 'neutral-10',
  NEUTRAL_25 = 'neutral-25',
  NEUTRAL_50 = 'neutral-50',
  NEUTRAL_75 = 'neutral-75',
  NEUTRAL_90 = 'neutral-90',
  NEUTRAL_95 = 'neutral-95',
  NEUTRAL_100 = 'neutral-100',
  OCEAN_5 = 'ocean-5',
  OCEAN_25 = 'ocean-25',
  OCEAN_50 = 'ocean-50',
  OCEAN_75 = 'ocean-75',
  OCEAN_100 = 'ocean-100',
  ORANGE_5 = 'orange-5',
  ORANGE_25 = 'orange-25',
  ORANGE_75 = 'orange-75',
  ORANGE_50 = 'orange-50',
  ORANGE_100 = 'orange-100',
  PRIMARY = 'primary',
  PURPLE_5 = 'purple-5',
  PURPLE_25 = 'purple-25',
  PURPLE_50 = 'purple-50',
  PURPLE_75 = 'purple-75',
  PURPLE_100 = 'purple-100',
  RED_5 = 'red-5',
  RED_25 = 'red-25',
  RED_50 = 'red-50',
  RED_75 = 'red-75',
  RED_100 = 'red-100',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning',
  WHITE = 'white',
  YELLOW_5 = 'yellow-5',
  YELLOW_25 = 'yellow-25',
  YELLOW_50 = 'yellow-50',
  YELLOW_75 = 'yellow-75',
  YELLOW_100 = 'yellow-100',
}
